document.addEventListener('DOMContentLoaded', function() {
  var readMoreLink = document.querySelector('.read-more');
  var readLessLink = document.querySelector('.read-less');
  var accordionContent = document.querySelector('.accordion-content');

  // Проверка наличия элементов
  if (!readMoreLink || !readLessLink || !accordionContent) {
    console.error('One or more elements not found');
    console.log('readMoreLink:', readMoreLink);
    console.log('readLessLink:', readLessLink);
    console.log('accordionContent:', accordionContent);
    return;
  }

  readMoreLink.addEventListener('click', function(event) {
    event.preventDefault();
    console.log('Read More clicked');
    accordionContent.style.display = 'block';
    readMoreLink.style.display = 'none';
  });

  readLessLink.addEventListener('click', function(event) {
    event.preventDefault();
    console.log('Read Less clicked');
    accordionContent.style.display = 'none';
    readMoreLink.style.display = 'inline';
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});